// compression.js — v2.0 : compression d'image côté client AVANT chiffrement.
// Si une image (JPEG/PNG/WebP) dépasse 2000 px de large, elle est
// redimensionnée via canvas et réencodée en JPEG qualité 0,85 — réduit le
// stockage sur le VPS. Le chiffrement s'applique toujours APRÈS compression.
// GIF exclu (animations). En cas d'échec (format exotique), l'original est
// conservé tel quel.
const MAX_WIDTH = 2000;

export async function maybeCompressImage(file, buf) {
  if (!/^image\/(jpeg|png|webp)$/.test(file.type)) return { buf, name: file.name };
  try {
    const bitmap = await createImageBitmap(new Blob([buf]));
    if (bitmap.width <= MAX_WIDTH) { bitmap.close(); return { buf, name: file.name }; }
    const scale = MAX_WIDTH / bitmap.width;
    const canvas = document.createElement('canvas');
    canvas.width = MAX_WIDTH;
    canvas.height = Math.round(bitmap.height * scale);
    canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    bitmap.close();
    const blob = await new Promise((res) => canvas.toBlob(res, 'image/jpeg', 0.85));
    if (!blob) return { buf, name: file.name };
    const out = await blob.arrayBuffer();
    if (out.byteLength >= buf.byteLength) return { buf, name: file.name }; // pas de gain
    return { buf: out, name: file.name.replace(/\.(png|webp|jpeg|jpg)$/i, '.jpg') };
  } catch (_) {
    return { buf, name: file.name };
  }
}
